import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Img, Text } from "components";
import { useState } from "react";
import { useAppFont } from "utils/helper/useAppFont";

const MakeItExtraProduct = ({ allCategories = [] }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [hoveredId, setHoveredId] = useState(null);
  const { interClass, interFamily, headingClass, headingFamily} = useAppFont();

  const items = allCategories.map((item) => ({
    id: item.id,
    slug: item?.slug || "",
    image: item?.categoryImages?.[0]?.Image || "/images/placeholder.png",
    title: item?.categoryLocales?.[0]?.name || "Category",
    count: item?.productCount ?? 0,
    price: item?.minPrice || item?.price || 15,
    isRecommended: item?.isRecommended || 0,
    isBestSeller: item?.isBestseller || 0,
  }));

  const handleCategoryClick = (slug, id) => {
    if (slug && id) {
      navigate(`/productlist/add-ons/${slug}/${id}`);
    }
  };

  return (
    <Box sx={{ width: "100%", py: 2 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 3,
          maxWidth: "1110px",
          mx: "auto",
        }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            className="
              relative
              flex
              flex-col
              w-full
              flex-shrink-0
              p-4
              gap-6
              rounded-[20px]
              border
              border-[#F7F7F7]
              bg-[#FFFFFF]
              transition-all
              duration-300
            "
            style={{
              transform: hoveredId === item.id ? 'translateY(-6px)' : 'translateY(0)',
              boxShadow: hoveredId === item.id ? '0 8px 24px rgba(119, 18, 55, 0.15)' : 'none',
            }}
            onMouseEnter={() => setHoveredId(item.id)}
            onMouseLeave={() => setHoveredId(null)}
          >
            <div
              className="
                relative
                w-full
                h-[180px]
                sm:h-[140px]
                md:h-[180px]
                rounded-xl
                overflow-hidden
                cursor-pointer
              "
              onClick={() => handleCategoryClick(item.slug, item.id)}
            >
              <Img
                src={item.image}
                alt={item.title}
                className="
                  w-full
                  h-full
                  object-cover
                  rounded-xl
                  transition-transform
                  duration-500
                  hover:scale-105
                "
              />

              {Number(item.isBestSeller) === 1 && (
                <div className="absolute top-3 right-3 bg-[#FFFFFF] sm:top-5 sm:right-5 bg-white px-3 py-1 sm:py-0 sm:px-2 rounded-full text-xs sm:text-[8px] font-medium text-[#E6A400] shadow">
                  Popular
                </div>
              )}

              {Number(item.isRecommended) === 1 && (
                <div
                  className="
                    absolute top-3 right-3 sm:top-5 sm:right-5
                    px-3 py-1 sm:px-2 sm:py-0
                    rounded-full
                    text-xs sm:text-[8px]
                    font-medium
                    shadow
                    bg-[#FFFFFF]
                  "
                >
                  <span
                    className="
                      bg-[linear-gradient(90deg,#30B5E8_0%,#1B6582_100%)]
                      bg-clip-text
                      text-transparent
                    "
                  >
                    {t("recommended")}
                  </span>
                </div>
              )}

            </div>

            <Text
              className={`
                text-base
                sm:text-xs
                font-normal
                text-[#771237]
                cursor-pointer
                line-clamp-1
                ${interClass}
                font-[16px]
                sm:font-[12px]
                px-2
              `}
              onClick={() => handleCategoryClick(item.slug, item.id)}
            >
              {item.title}
            </Text>

            <div className="flex items-center gap-2 px-2 sm:px-4">
              <span className="flex items-center gap-[10px] text-xl font-semibold sm:text-xs text-[#771237]">
                <span
                  className="
                    flex
                    w-[20px]
                    h-[20px]
                    py-[1px]
                    justify-center
                    items-center
                  "
                >
                  <img
                    src="/images/Groupsar.svg"
                    alt="icon"
                    className="w-full h-full object-contain"
                  />
                </span>

                <span>{item.price}</span>
              </span>
            </div>

            <div className="flex flex-row gap-2">
             <Button
                className={`
                    w-full
                    h-12
                    sm:w-full
                    sm:h-8
                    rounded-full
                    border border-[#E6E6E6]
                    bg-[#FFFFFF]
                    text-[#1A1A1A]
                    text-center
                    ${headingClass}
                    text-[16px]
                    font-medium
                    leading-6
                    transition-all duration-300
                    hover:text-[#771237]
                    hover:border-[#771237]
                    btn-spread
                `}
                onClick={() => handleCategoryClick(item.slug, item.id)}
                >
                {t('addToCart')}
                </Button>
            </div>
          </div>
        ))}
      </Box>
    </Box>
  );
};

export default MakeItExtraProduct;